import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type", "tag"];
import React from 'react';
import { typeComponents } from './style';
var Text = function Text(_ref) {
  var type = _ref.type,
    tag = _ref.tag,
    rest = _objectWithoutProperties(_ref, _excluded);
  var TypeComponent = typeComponents[type];
  var props = Object.assign({}, rest, {
    as: tag
  });
  return /*#__PURE__*/React.createElement(TypeComponent, props);
};
Text.defaultProps = {
  type: 'body',
  lineHeight: 'default',
  strikeThrough: false
};
export default Text;